import { createReducer, on, Action } from '@ngrx/store';

import * as SessionActions from './session.actions';
import { SessionDataMapped } from '@airtradeit/authentication';

// tslint:disable-next-line: no-empty-interface // TODO
export interface SessionState extends SessionDataMapped {}

const initialState: SessionState = null;

const reducer = createReducer(
  initialState,
  on(SessionActions.setSession, (state, { data }): SessionDataMapped => ({ ...data } as SessionDataMapped))
);

export function sessionReducer(state: SessionState, action: Action) {
  return reducer(state, action);
}
